import axios from 'axios'

let isDev = process.env.NODE_ENV === 'development';

// axios throws exceptions for 400 level status codes. We don't want this!
axios.interceptors.response.use((response) => {
    return response;
}, function (error) {
    if (error.response.status < 500) {
        return Promise.resolve(error.response);
    }
    return error;
});

export default {
    apiUrl: isDev ? 'https://localhost:7006/api/' : '/api/',
    clientWebSocketUrl: isDev ? 'https://localhost:7006/game-client' : '/game-client',
    hostWebSocketUrl: isDev ? 'https://localhost:7006/host-client' : '/host-client',
}